
export interface ICoordinator {
  id: number;
  coordinatorName: string;
  coordinatorMail: string;
  role: number;
  header: string;
  footer: string;
  permistion: string;
}

export class CCoordinator implements ICoordinator {
  public id = 0;
  public coordinatorName = '';
  public coordinatorMail = '';
  public role = 2;
  public header = '';
  public footer = '';
  public permistion = '';
}


export interface ICoordinatorRank {
  coordinatorID: number;
  a: boolean;
  b: boolean;
  c: boolean;
  d: boolean;
}

export class CCoordinatorRank implements ICoordinatorRank {
  public coordinatorID = 0;
  public a = true;
  public b = true;
  public c = true;
  public d = true;
}

export interface IClient {
  id: number;
  companyName: string;
  address: string;
  addressHeadOffice: string;
  tel: string;
  url: string;
  capital: number;
  employees: string;
  clientName: string;
  clientMail: string;
  deliveryMail: string;
  engineerDelivery: boolean;
  annkennDelivery: boolean;
  stopDelivery: boolean;
  comment: string;
  createDate: string;
  updateDate: string;
  stopFlag: boolean;
  systemStopFlag: number;
  rank: number;
}

export class CClient implements IClient {
  public id = 0;
  public companyName = '';
  public address = '';
  public addressHeadOffice = '';
  public tel = '';
  public url = '';
  public capital = 0;
  public employees = '';
  public clientName = '';
  public clientMail = '';
  public deliveryMail = '';
  public engineerDelivery = true;
  public annkennDelivery = true;
  public stopDelivery = false;
  public comment = '';
  public createDate = '';
  public updateDate = '';
  public stopFlag = false;
  public systemStopFlag = 0;
  public rank = 4;
}

export interface VClient {
  clients: IClient[],
  coordinators: ICoordinator[],
}

export interface IEngineer {
  id: number;
  engineerName: string;
  initials: string;
  responsibleID: number;
  responsibleName: string;
  subject: string;
  introduction: string;
  attachmentUrl: string;
  attachmentName: string;
  createDate: string;
  updateDate: string;
  sendDate: string;
}


export class CEngineer implements IEngineer {
  public id = 0;
  public engineerName = '';
  public initials = '';
  public responsibleID = 0;
  public responsibleName = '';
  public subject = '';
  public introduction = '';
  public attachmentUrl = '';
  public attachmentName = '';
  public createDate = '';
  public updateDate = '';
  public sendDate = '';
}

export interface IAuth {
  mail: string;
  password: string;
  confirmPassword: string;
  accessToken: string;
}

export class CAuth implements IAuth {
  public mail = '';
  public password = '';
  public confirmPassword = '';
  public accessToken = '';
}

export interface IConfirm {
  mail: string;
  password: string;
  code: string;
}

export class CConfirm implements IConfirm {
  public mail = '';
  public password = '';
  public code = '';
}

export interface VEngineer {
  engineers: IEngineer[],
  coordinators: ICoordinator[],
  clients: IClient[],
  count: number,
}

export interface VGetDatas {
  datas: any[]
  engineers: IEngineer[],
  coordinators: ICoordinator[],
  clients: IClient[],
  coordinatorsRanks: ICoordinatorRank[],
  count: number,
}

export interface VSkillsheet {
  engineer: IEngineer,
  file: File,
}

export interface IEngineerReject {
  engineerID: number;
  clientID: number;
}

export class CEngineerReject implements IEngineerReject {
  public engineerID = 0;
  public clientID = 0;
}

export interface VEngineerReject {
  engineerReject: IEngineerReject[],
}

export interface IAnnkenn {
  id: number;
  subject: string;
  responsibleID: number,
  responsibleName: string;
  introduction: string;
  attachmentUrl: string;
  createDate: string;
  updateDate: string;
  sendDate: string;
}

export class CAnnkenn implements IAnnkenn {
  public id = 0;
  public subject = '';
  public responsibleID = 0;
  public responsibleName = '';
  public introduction = '';
  public attachmentUrl = '';
  public createDate = '';
  public updateDate = '';
  public sendDate = '';
}

export interface VAnnkenn {
  annkenns: IAnnkenn[],
  coordinators: ICoordinator[],
  clients: IClient[],
  count: number,
}

export interface VMail {
  engineers: IEngineer[],
  annkenns: IAnnkenn[],
  coordinators: ICoordinator[],
  clients: IClient[],
  mails: IMail[],
  count: number,
  coordinatorsRanks: ICoordinatorRank[],
}

export interface IMail {
  id: number,
  responsibleID: number,
  createdID: number,
  engineerID: number,
  annkennID: number,
  subject: string,
  text: string,
  attachmentUrl: string,
  attachmentName: string,
  type: number,
  createdDate: string,
  success: number,
  failure: number,
  sendDate: Date,
  sendType: number,
  sendStatus: number,
}

export class CMail implements IMail {
  public id = 0;
  public responsibleID = 0;
  public createdID = 0;
  public engineerID = 0;
  public annkennID = 0;
  public subject = '';
  public text = '';
  public attachmentUrl = '';
  public attachmentName = '';
  public type = 0 ;
  public createdDate = '';
  public success = 0;
  public failure = 0;
  public sendDate = new Date();
  public sendType = 0;
  public sendStatus = 0;
}

export interface VSendData {
  mail: IMail,
  clients: number[],
}


export interface ISendEditData {
  mail: IMail,
  data: IEngineer | IAnnkenn,
  coordinator: ICoordinator,
  clients: IClient[],
}

export class CSendEditData implements ISendEditData {
  public mail = new CMail() ;
  public data = {} as IEngineer | IAnnkenn ;
  public coordinator = {} as ICoordinator ;
  public clients = [] as IClient[] ;
}

export interface IAnnkennReject {
  annkennID: number;
  clientID: number;
}

export class CAnnkennReject implements IAnnkennReject {
  public annkennID = 0;
  public clientID = 0;
}

export interface VAnnkennReject {
  annkennReject: IAnnkennReject[],
}

export interface ILocalData {
  target: string,
  asc: boolean,
  disp: boolean[],
  word: string,
  searchIDs: number[],
}

export class CLocalData implements ILocalData {
  public target = '';
  public asc = false;
  public disp = [] as boolean[];
  public word = '';
  public searchIDs = [] as number[];
  constructor(target: string, disp: any[]) {
    this.target = target;
    this.disp = disp.map(() => (true));
  }
}

export interface ILocalDatas {
  annkenn: ILocalData,
  client: ILocalData,
  engineer: ILocalData,
  mail: ILocalData,
  mailAnnkenn: ILocalData,
  mailEngineer: ILocalData,
}

export class CLocalDatas implements ILocalDatas {
  public annkenn = {} as ILocalData;
  public client = {} as ILocalData;
  public engineer = {} as ILocalData;
  public mail = {} as ILocalData;
  public mailAnnkenn = {} as ILocalData;
  public mailEngineer = {} as ILocalData;
}

export interface ISortData {
  target: string,
  asc: boolean,
}

export interface IGetDatas {
  getCoordinatorDatas: ICoordinator[],
  getClientDatas: IClient[],
  getEngineerDatas: IEngineer[],
  getAnnkennDatas: IAnnkenn[],
  getMailDatas: IMail[],
}

export class CGetDatas implements IGetDatas {
  public getCoordinatorDatas = [] as ICoordinator[];
  public getClientDatas = [] as IClient[];
  public getEngineerDatas = [] as IEngineer[];
  public getAnnkennDatas = [] as IAnnkenn[];
  public getMailDatas = [] as IMail[];
}
